import { environment } from 'src/environments/environment';

// Always-on Azure-hosted backend, used by the Developer Controls "Use Azure Server"
// toggle so local development works against real data without running the server locally.
export const AZURE_API_URL = 'https://fflxcel.azurewebsites.net/api';
export const AZURE_WEBSOCKET_URL = 'https://fflxcel.azurewebsites.net';

const LOCAL_API_URL = 'http://localhost:3000/api';

/**
 * Developer Controls > "Use Azure Server" toggle (dev builds only).
 * Defaults to Azure so a fresh checkout works without a local server running;
 * an explicit 'false' in localStorage switches to the local server instead.
 */
export function shouldUseAzureServer(): boolean {
  return localStorage.getItem('use_azure_server') !== 'false';
}

/** Rewrites a hardcoded local API URL for the current environment/toggle. Used by AuthInterceptorService. */
export function resolveApiUrl(url: string): string {
  if (!url.includes(LOCAL_API_URL)) return url;

  if (environment.production) {
    return url.replace(LOCAL_API_URL, '/api');
  }
  if (shouldUseAzureServer()) {
    return url.replace(LOCAL_API_URL, AZURE_API_URL);
  }
  return url;
}

/** Websocket base URL honoring the same dev toggle. Used by WebsocketService. */
export function resolveWebsocketUrl(): string {
  if (environment.production) return environment.websocketUrl;
  return shouldUseAzureServer() ? AZURE_WEBSOCKET_URL : environment.websocketUrl;
}
